import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getReportsList} from "../../../../redux/Selectors/reports.selectors";
import {requestReports} from "../../../../redux/Actions/reports.actions";

export const useReportTableData = () => {
  const dispatch = useDispatch();
  const reportList = useSelector(getReportsList);

  useEffect(() => {
    dispatch(requestReports());
  }, [dispatch]);

  return {reportList};
};
